import {
  CapaErrorCode,
  useFetchMyQuotationUserQuery
} from '@generated/graphql';
import { Drawer, makeStyles } from '@material-ui/core';
import errorMessage from '@utils/errorMessage';
import { useSnackbar } from 'notistack';
import React, { useRef } from 'react';
import useViewerApiContext from '../context/useViewerApiContext';
import CommentInput from './CommentInput';
import UserAvatar from './UserAvatar';

const AnnotationAddDrawer: React.FunctionComponent<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { onGetNewAnnotationData } = useViewerApiContext();
  const { annotationInputContainer } = useStyles();
  const commentRef = useRef<string>('');
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { data } = useFetchMyQuotationUserQuery({
    fetchPolicy: 'cache-only'
  });
  const myName = data?.fetchMyQuotationUser.data?.managerName ?? '';
  const { enqueueSnackbar } = useSnackbar();

  const onAddComment = async () => {
    if (!inputRef.current || !onGetNewAnnotationData) return;
    try {
      await onGetNewAnnotationData(commentRef.current);
      inputRef.current.value = '';
    } catch (e) {
      if (e.message === CapaErrorCode.ChatroomNotOpened) {
        enqueueSnackbar(errorMessage.notOpendChatroomCreateAnnotationComment);
      } else {
        enqueueSnackbar(errorMessage.createAnnotation);
      }
    }
  };

  return (
    <Drawer open={open} anchor="bottom" onClose={onClose}>
      <div className={annotationInputContainer}>
        <UserAvatar userName={myName} />
        <CommentInput
          placeholder="주석을 입력하세요."
          commentRef={commentRef}
          inputRef={inputRef}
          onAddComment={onAddComment}
        />
      </div>
    </Drawer>
  );
};

export default AnnotationAddDrawer;

const useStyles = makeStyles((theme) => ({
  annotationInputContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    gap: '16px'
  }
}));
